import useUserController from "@admin/api/useUserController"
import useActions from "./hooks/useActions"
import useApi from "./hooks/useApi"
import useAttributes from "./hooks/useAttributes"
import useHooks from "./hooks/useHooks"
import useMethods from "./hooks/useMethods"

export default function useUser(id: string | number): Admin.Models.User {
    const controller = useUserController()
    const response = controller.show(id).use()

    const attrs = useAttributes(response)
    const api = useApi(id, controller)
    const methods = useMethods(response)
    const actions = useActions(response, api, methods)
    const use = useHooks(response, api, methods, actions)

    return { 
        state: response.data, 
        setState: response.setData, 
        fresh: response.fresh,
        attrs,
        api,
        methods,
        actions,
        use
    }
}